
function Perguntasfrequentes(){
    return(
<>
        <div class="accordion accordion-flush" id="accordionFlush">
  <div class="accordion-item">
    <h2 class="accordion-header" id="flush-heading1">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse1" aria-expanded="false" aria-controls="flush-collapse1">
      COMO FUNCIONA O SUPORTE DA EMPRESA? </button>
    </h2>
    <div id="flush-collapse1" class="accordion-collapse collapse" aria-labelledby="flush-heading1" data-bs-parent="#accordionFlush">
      <div class="accordion-body">
      Basta entrar em contato por algum dos nossos canais de atendimento, que de acordo com o grau do problema imediatamente abrimos uma O.S para os técnicos estarem indo até a residência do cliente para realizar o reparo sem custos adicionais
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="flush-heading2">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse2" aria-expanded="false" aria-controls="flush-collapse2">
      QUANTAS HORAS PARA REALIZAR A INSTALAÇÃO?
      </button>
    </h2>
    <div id="flush-collapse2" class="accordion-collapse collapse" aria-labelledby="flush-heading2" data-bs-parent="#accordionFlush">
      <div class="accordion-body">
      Os Técnicos tem um prazo de até 48 horas para realizar a instalação descrito mediante contrato, mas procuramos fazer no melhor horário disponivél para o cliente. 
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="flush-heading3">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse3" aria-expanded="false" aria-controls="flush-collapse3">
      PRECISO PAGAR OS EQUIPAMENTOS QUE VÃO SER INSTALADOS?
      </button>
    </h2>
    <div id="flush-collapse3" class="accordion-collapse collapse" aria-labelledby="flush-heading3" data-bs-parent="#accordionFlush">
      <div class="accordion-body">
      Não, todos os equipamentos são por nossa conta, tendo qualquer problema fazemos a troca sem nenhum custo adicional.
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="flush-heading4">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse4" aria-expanded="false" aria-controls="flush-collapse4">
      COMO É COBRADO A INSTALAÇÃO?
      </button>
    </h2>
    <div id="flush-collapse4" class="accordion-collapse collapse" aria-labelledby="flush-heading4" data-bs-parent="#accordionFlush">
      <div class="accordion-body">
      Não temos taxa de adesão. Os custos da instalação é totalmente anexado aos meses de fidelidade.
      </div>
    </div>
  </div>

  <div class="accordion-item bg">
    <h2 class="accordion-header" id="flush-heading5">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse5" aria-expanded="false" aria-controls="flush-collapse5">
      POSSO CONTRATAR A INTERNET COM RESTRIÇÃO NO CPF?
      </button>
    </h2>
    <div id="flush-collapse5" class="accordion-collapse collapse" aria-labelledby="flush-heading5" data-bs-parent="#accordionFlush">
      <div class="accordion-body">
      Nós da Netsim Telecom terceirizamos o setor de cadastro e uma exigência é que não tenha nenhuma restrição no CPF.
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="flush-heading6">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse6" aria-expanded="false" aria-controls="flush-collapse6">
      TEM FIDELIDADE CONTRATUAL?
      </button>
    </h2>
    <div id="flush-collapse6" class="accordion-collapse collapse" aria-labelledby="flush-heading6" data-bs-parent="#accordionFlush">
      <div class="accordion-body">
      Sim, temos uma fidelidade contratual de apenas 12 meses, apenas para cobrir os custos do cliente. A menos que, o cliente opte em pagar a taxa de adesão de 500 reais não terá fidelidade. 
      </div>
    </div>
  </div>
</div>
</div>
</>
    )
}
export default Perguntasfrequentes;